import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SEO from "./seo";
const HelpCenterHomepage = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  // Your existing data structure remains the same
  const helpSections = [
    {
      title: "Getting Started",
      description: "Learn the basics and set up your xPAGE store",
      items: [
        {
          id: "introduce-xpage",
          title: "Introduce xPAGE",
          description:
            "Get familiar with xPAGE platform features and capabilities.",
          icon: (
            <svg
              width="40"
              height="40"
              viewBox="0 0 53 53"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M48.5833 36.9675V10.3129C48.5833 7.66295 46.4191 5.69753 43.7912 5.91836H43.6587C39.0212 6.31586 31.9766 8.67878 28.0458 11.1521L27.6704 11.395C27.03 11.7925 25.97 11.7925 25.3295 11.395L24.7775 11.0638C20.8466 8.61253 13.8241 6.2717 9.18663 5.89628C6.55871 5.67545 4.41663 7.66295 4.41663 10.2909V36.9675C4.41663 39.0875 6.13913 41.075 8.25913 41.34L8.89954 41.4284C13.6916 42.0688 21.0895 44.4979 25.3295 46.8167L25.4179 46.8609C26.0141 47.1921 26.9637 47.1921 27.5379 46.8609C31.7779 44.52 39.1979 42.0688 44.012 41.4284L44.7408 41.34C46.8608 41.075 48.5833 39.0875 48.5833 36.9675Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M26.5 12.1238V45.2488"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17.1146 18.7488H12.1459"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M18.7709 25.3738H12.1459"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
        },
        {
          id: "quick-start-guide",
          title: "Quick Start Guide",
          description: "Step-by-step guide to quickly set up your xPAGE store.",
          icon: (
            <svg
              width="40"
              height="40"
              viewBox="0 0 53 53"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M39.75 13.25H13.25C8.38163 13.25 4.41663 17.215 4.41663 22.0833V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V22.0833C48.5833 17.215 44.6184 13.25 39.75 13.25Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19.875 13.25V9.9375C19.875 7.40167 21.9017 5.375 24.4375 5.375H28.5625C31.0983 5.375 33.125 7.40167 33.125 9.9375V13.25"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19.875 23.1875H33.125"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19.875 30.9166H33.125"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19.875 38.6458H26.5"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M30.9166 38.6458C32.8729 38.6458 34.4583 37.0604 34.4583 35.1041C34.4583 33.1479 32.8729 31.5625 30.9166 31.5625C28.9604 31.5625 27.375 33.1479 27.375 35.1041C27.375 37.0604 28.9604 38.6458 30.9166 38.6458Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
        },
        {
          id: "pricing-plans",
          title: "Pricing Plans",
          description:
            "Explore xPAGE pricing options and choose the right plan.",
          icon: (
            <svg
              width="40"
              height="40"
              viewBox="0 0 53 53"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M31.4947 35.329H20.453"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M27.9575 5.56084L27.8913 5.71543L21.4871 20.5775H15.1934C13.6917 20.5775 12.2563 20.8867 10.9534 21.4388L14.818 12.2079L14.9063 11.9871L15.0609 11.6338C15.105 11.5013 15.1492 11.3688 15.2155 11.2583C18.1084 4.56709 21.3767 3.04334 27.9575 5.56084Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M39.8604 21.0192C38.8666 20.7101 37.8066 20.5776 36.7466 20.5776H21.4871L27.8912 5.7155L27.9575 5.56091C28.2887 5.67133 28.5979 5.82591 28.9291 5.95841L33.8096 8.01216C36.5258 9.13841 38.425 10.3088 39.5733 11.7222C39.7941 11.9872 39.9708 12.2301 40.1254 12.5172C40.3241 12.8263 40.4787 13.1355 40.5671 13.4667C40.6554 13.6655 40.7216 13.8642 40.7658 14.0409C41.3621 15.8959 41.0087 18.1705 39.8604 21.0192Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M47.5271 31.3547V35.6609C47.5271 36.1026 47.505 36.5443 47.4829 36.9859C47.0633 44.693 42.7571 48.5797 34.5863 48.5797H17.3613C16.8313 48.5797 16.3013 48.5355 15.7933 48.4693C8.77084 48.0055 5.01667 44.2513 4.55292 37.2288C4.48667 36.7209 4.4425 36.1909 4.4425 35.6609V31.3547C4.4425 26.9159 7.13667 23.0955 10.9792 21.4393C12.3042 20.8872 13.7175 20.578 15.2192 20.578H36.7725C37.8546 20.578 38.9146 20.7326 39.8863 21.0197C44.2808 22.3668 47.5271 26.4743 47.5271 31.3547Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M14.8179 12.208L10.9533 21.4388C7.11079 23.0951 4.41663 26.9155 4.41663 31.3543V24.8838C4.41663 18.6122 8.87746 13.3784 14.8179 12.208Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M47.5202 24.8828V31.3532C47.5202 26.4949 44.2961 22.3653 39.8794 21.0403C41.0277 18.1694 41.359 15.9169 40.8069 14.0399C40.7627 13.8411 40.6965 13.6424 40.6081 13.4657C44.7156 15.5857 47.5202 19.9361 47.5202 24.8828Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
        },
      ],
    },
    {
      title: "Store Setup",
      description: "Configure and launch your xPAGE store",
      items: [
        {
          id: "quick-launch-checklist",
          title: "Quick Launch Checklist",
          description: "Essential steps to quickly launch your xPAGE store.",
          icon: (
            <svg
              width="40"
              height="40"
              viewBox="0 0 53 53"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.72913 39.75V15.4583C7.72913 6.62496 9.93746 4.41663 18.7708 4.41663H34.2291C43.0625 4.41663 45.2708 6.62496 45.2708 15.4583V37.5416C45.2708 37.8508 45.2708 38.16 45.2487 38.4691"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M14.0229 33.125H45.2708V40.8542C45.2708 45.1162 41.8037 48.5833 37.5416 48.5833H15.4583C11.1962 48.5833 7.72913 45.1162 7.72913 40.8542V39.4188C7.72913 35.9517 10.5558 33.125 14.0229 33.125Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17.6666 15.4584H35.3333"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17.6666 23.1875H28.7083"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
        },
        {
          id: "landing-page-setup",
          title: "Landing Page Setup",
          description:
            "Configure and optimize your landing page for maximum conversion.",
          icon: (
            <svg
              width="40"
              height="40"
              viewBox="0 0 53 53"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M39.75 4.41663H13.25C8.38163 4.41663 4.41663 8.38163 4.41663 13.25V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V13.25C48.5833 8.38163 44.6184 4.41663 39.75 4.41663Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19.875 19.875H33.125"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19.875 28.7083H33.125"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19.875 37.5416H26.5"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
        },
        {
          id: "landing-page-compliance",
          title: "Landing Page Compliance",
          description:
            "Ensure your landing page meets all compliance requirements.",
          icon: (
            <svg
              width="40"
              height="40"
              viewBox="0 0 53 53"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.1666 44.1666H13.25C9.00996 44.1666 5.58329 40.74 5.58329 36.5V13.25C5.58329 9.00996 9.00996 5.58329 13.25 5.58329H39.75C43.99 5.58329 47.4166 9.00996 47.4166 13.25V21.1666"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19.875 26.5L24.2917 30.9167L33.125 22.0833"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M39.75 30.9166C43.99 30.9166 47.4166 34.3433 47.4166 38.5833C47.4166 42.8233 43.99 46.25 39.75 46.25C35.51 46.25 32.0833 42.8233 32.0833 38.5833C32.0833 34.3433 35.51 30.9166 39.75 30.9166Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M39.75 34.4729V38.5833H43.8604"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
        },
      ],
    },
    {
      title: "Account & Platform",
      description: "Manage your account and understand the platform",
      items: [
        {
          id: "understand-xpage",
          title: "Understand xPAGE",
          description: "Deep dive into xPAGE features and functionality.",
          icon: (
            <svg
              width="40"
              height="40"
              viewBox="0 0 53 53"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M26.5 48.5833C38.6962 48.5833 48.5833 38.6962 48.5833 26.5C48.5833 14.3037 38.6962 4.41663 26.5 4.41663C14.3037 4.41663 4.41663 14.3037 4.41663 26.5C4.41663 38.6962 14.3037 48.5833 26.5 48.5833Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M26.5 17.6666V26.5L31.9375 31.9375"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
        },
        {
          id: "landing-page-account",
          title: "Landing Page & Account",
          description: "Connect your landing page with account settings.",
          icon: (
            <svg
              width="40"
              height="40"
              viewBox="0 0 53 53"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M39.75 13.25H13.25C8.38163 13.25 4.41663 17.215 4.41663 22.0833V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V22.0833C48.5833 17.215 44.6184 13.25 39.75 13.25Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M13.25 13.25V9.93746C13.25 6.62496 15.4583 4.41663 18.7708 4.41663H34.2291C37.5416 4.41663 39.75 6.62496 39.75 9.93746V13.25"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M26.5 35.3333C29.8135 35.3333 32.5 32.6468 32.5 29.3333C32.5 26.0198 29.8135 23.3333 26.5 23.3333C23.1865 23.3333 20.5 26.0198 20.5 29.3333C20.5 32.6468 23.1865 35.3333 26.5 35.3333Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M35.3333 35.3333L33.125 33.125"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
        },
      ],
    },
    {
      title: "Store Operations",
      description: "Manage your daily store operations and business growth",
      items: [
        {
          id: "store-operation",
          title: "Store Operation",
          description: "Manage daily store operations and workflows.",
          icon: (
            <svg
              width="40"
              height="40"
              viewBox="0 0 53 53"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M39.75 17.6666H13.25C8.38163 17.6666 4.41663 21.6316 4.41663 26.5V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V26.5C48.5833 21.6316 44.6184 17.6666 39.75 17.6666Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17.6666 17.6666V13.25C17.6666 9.00996 21.0933 5.58329 25.3333 5.58329H27.6666C31.9066 5.58329 35.3333 9.00996 35.3333 13.25V17.6666"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M26.5 35.3333C29.8135 35.3333 32.5 32.6468 32.5 29.3333C32.5 26.0198 29.8135 23.3333 26.5 23.3333C23.1865 23.3333 20.5 26.0198 20.5 29.3333C20.5 32.6468 23.1865 35.3333 26.5 35.3333Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
        },
        {
          id: "business-expansion",
          title: "Business Expansion",
          description: "Strategies and tools for growing your business.",
          icon: (
            <svg
              width="40"
              height="40"
              viewBox="0 0 53 53"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M26.5 48.5833C38.6962 48.5833 48.5833 38.6962 48.5833 26.5C48.5833 14.3037 38.6962 4.41663 26.5 4.41663C14.3037 4.41663 4.41663 14.3037 4.41663 26.5C4.41663 38.6962 14.3037 48.5833 26.5 48.5833Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M33.125 19.875L26.5 26.5L19.875 33.125"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M33.125 33.125H19.875V19.875"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
        },
        {
          id: "settings",
          title: "Settings",
          description: "Configure your xPAGE store settings and preferences.",
          icon: (
            <svg
              width="40"
              height="40"
              viewBox="0 0 53 53"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M26.5 31.9375C29.8135 31.9375 32.5 29.251 32.5 25.9375C32.5 22.624 29.8135 19.9375 26.5 19.9375C23.1865 19.9375 20.5 22.624 20.5 25.9375C20.5 29.251 23.1865 31.9375 26.5 31.9375Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M44.1666 31.9375C42.3875 31.9375 41.1458 33.1792 41.1458 34.9583C41.1458 36.7375 42.3875 37.9792 44.1666 37.9792C45.9458 37.9792 47.1875 36.7375 47.1875 34.9583C47.1875 33.1792 45.9458 31.9375 44.1666 31.9375Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.83329 31.9375C7.05413 31.9375 5.81246 33.1792 5.81246 34.9583C5.81246 36.7375 7.05413 37.9792 8.83329 37.9792C10.6125 37.9792 11.8541 36.7375 11.8541 34.9583C11.8541 33.1792 10.6125 31.9375 8.83329 31.9375Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M34.9583 8.83329C34.9583 10.6125 33.7166 11.8541 31.9375 11.8541C30.1583 11.8541 28.9166 10.6125 28.9166 8.83329C28.9166 7.05413 30.1583 5.81246 31.9375 5.81246C33.7166 5.81246 34.9583 7.05413 34.9583 8.83329Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M34.9583 44.1666C34.9583 45.9458 33.7166 47.1875 31.9375 47.1875C30.1583 47.1875 28.9166 45.9458 28.9166 44.1666C28.9166 42.3875 30.1583 41.1458 31.9375 41.1458C33.7166 41.1458 34.9583 42.3875 34.9583 44.1666Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19.875 13.25L23.1875 15.4583L29.3333 11.8542"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19.875 37.9792L23.1875 35.7708L29.3333 39.375"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
        },
        {
          id: "apps",
          title: "Apps",
          description: "Explore and manage xPAGE apps and integrations.",
          icon: (
            <svg
              width="40"
              height="40"
              viewBox="0 0 53 53"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M39.75 13.25H13.25C8.38163 13.25 4.41663 17.215 4.41663 22.0833V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V22.0833C48.5833 17.215 44.6184 13.25 39.75 13.25Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17.6666 8.83329V17.6666"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M35.3333 8.83329V17.6666"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19.875 26.5H33.125"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19.875 33.125H28.7083"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
        },
      ],
    },
  ];

  const handleCardClick = (itemId) => {
    navigate(`/help/${itemId}`);
  };

  // Filter items based on search query
  const filteredSections = helpSections
    .map((section) => ({
      ...section,
      items: section.items.filter(
        (item) =>
          item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
          section.title.toLowerCase().includes(searchQuery.toLowerCase()),
      ),
    }))
    .filter((section) => section.items.length > 0);

  return (
    <div className="min-h-screen bg-systemBackground flex flex-col md:pt-10 pt-16">
      <SEO
        title="xPage Help Center - Guides & Tutorials for Your Store"
        description="Find step-by-step guides, tutorials, and FAQs to help you set up, manage, and grow your xPage store."
        keywords="xPage help center, store setup guide, ecommerce support, tutorials, FAQs"
        canonical="https://help-center.preprod-myxpage.shop/"
        type="website"
      />

      {/* Main content area that grows and pushes footer down */}
      <div className="flex-1 w-full py-6 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-6">
            <h1 className="text-2xl font-semibold text-systemTitle mb-3">
              xPage Help Center
            </h1>

            {/* Search Bar */}
            <div className="max-w-2xl mx-auto">
              <div className="relative pt-2">
                <input
                  type="text"
                  placeholder="Search ..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-500 rounded-2xl shadow-sm focus:ring-2 focus:ring-deepPurple focus:border-deepPurple text-sm placeholder-gray-400 transition-all duration-200 bg-white"
                />
                <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                  <svg
                    className="w-5 h-5 text-gray-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Help Sections */}
          <div className="space-y-6 mb-6">
            {filteredSections.map((section, sectionIndex) => (
              <div
                key={sectionIndex}
                className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden"
              >
                {/* Section Header */}
                <div className="bg-gray-100 px-4 py-3 border-b border-gray-200">
                  <div className="flex items-start justify-between">
                    <div>
                      <h2 className="text-sm font-semibold text-systemTitle mb-1">
                        {section.title}
                      </h2>
                      <p className="text-sm text-systemSubTitle">
                        {section.description}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Cards Grid - 3 columns */}
                <div className="p-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {section.items.map((item, itemIndex) => (
                      <div
                        key={itemIndex}
                        onClick={() => handleCardClick(item.id)}
                        className="group relative bg-white border border-gray-200 rounded-xl p-4 hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1 cursor-pointer hover:border-systemLabel"
                      >
                        {/* Hover effect background */}

                        <div className="relative z-10">
                          {/* Icon and Title */}
                          <div className="flex items-center space-x-3 mb-3">
                            <div className="flex-shrink-0 w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center transition-colors duration-300">
                              {item.icon}
                            </div>
                            <h3 className="text-lg font-semibold text-systemTitle transition duration-300">
                              {item.title}
                            </h3>
                          </div>

                          {/* Description */}
                          <p className="text-sm text-systemLabel leading-relaxed transition-colors duration-300">
                            {item.description}
                          </p>

                          {/* Hover arrow indicator */}
                          <div className="absolute right-3 top-3 opacity-0 group-hover:opacity-100 transform translate-x-2 group-hover:translate-x-0 transition-all duration-300">
                            <svg
                              className="w-6 h-6 text-base"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 5l7 7-7 7"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* No results message */}
          {filteredSections.length === 0 && (
            <div className="text-center py-12 mb-6">
              <div className="text-gray-400 text-6xl mb-4">🔍</div>
              <h3 className="text-sm font-semibold text-systemTitle mb-2">
                No results found
              </h3>
              <p className="text-sm text-systemLabel">
                Try searching with different keywords
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Fixed Footer - This will always stay at the bottom */}
      <footer className="mt-auto bg-systemBackground border-t border-gray-200 py-4 w-full">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-sm text-gray-600">
            © xPage Inc. {new Date().getFullYear()}
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HelpCenterHomepage;
